<template>
  <v-icon class="info-icon" color="black"> mdi-information-outline </v-icon>
</template>
<script>
/**
 * @description Componente que exibe o icone de info
 */
export default {
  name: "InfoIcon",
  props: {
    color: {
      type: String,
      default: "black",
    },
    size: {
      type: String,
      default: "1.5rem",
    },
  },
  computed: {
    iconColor() {
      switch (this.color) {
        case "white":
          return "info-icon";
        case "black":
          return "info-icon-black";
        default:
          return "info-icon";
      }
    },
    iconSize() {
      switch (this.size) {
        case "small":
          return "small";
        case "medium":
          return "medium";
        case "large":
          return "large";
        default:
          return "medium";
      }
    },
    iconClass() {
      return this.iconColor + " " + this.iconSize;
    },
  },
};
</script>
<style scoped>
.info-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.info-icon:hover {
  fill: var(--dl-color-gray-white);
  cursor: pointer;
}

.info-icon-black {
  width: 1.5rem;
  height: 1.5rem;
}

.info-icon-black:hover {
  fill: var(--dl-color-gray-700);
  cursor: pointer;
}

.small {
  width: 1rem;
  height: 1rem;
}

.medium {
  width: 1.25rem;
  height: 1.25rem;
}

.large {
  width: 2rem;
  height: 2rem;
}
</style>
